import { LoadingActions } from '../ActionTypes';

export const setActivity = (state) => ({
    type: LoadingActions.SetActivity,
    state
});
